
<div class="set-match-row set-match-item">
  <checkbox
    :value="selected"
    class="set-match-checkbox"
    @input="$emit('toggle', $event)"
  />

  <div class="set-match-main">
    <span class="set-match-label">
      {{ item.subject || '—' }} {{ item.number || item.numberSlug || '—' }}
    </span>

    <div class="set-match-details">
      <div
        v-for="p in item.profiles || []"
        :key="p.profileId"
        class="set-match-detail-row"
      >
        <span class="set-match-detail-label">
          {{ p.label || '—' }}
        </span>
        <pill readonly no-margin>
          {{ graderLabel(p.grader) }}
        </pill>
      </div>
    </div>
  </div>
</div>
